export enum EAprilMadnessEventLevelStatus {
  TAKEN = 'taken',
  AVAILABLE = 'available',
  DISABLED = 'disabled',
}
